
<template>
  <div class="card">
    <!-- <header>
      <img
        class="avatar"
        width="40"
        height="40"
        :alt="user.realname"
        :src="user.photo"
      />
      <p class="name">{{ user.realname }}</p>
    </header> -->
    <footer>
      <input
        class="search"
        type="text"
        placeholder="search user..."
        @keyup="onKeyup"
      />
    </footer>
  </div>
</template>
<script>
// import { actions } from "../store";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      filterKey: (state) => state.chat.filterKey,
      // 当前"我"的信息
      user: (state) => state.chat.user,
    }),
  },
  // vuex: {
  //   actions: actions,
  //   getters: {
  //     user: ({ user }) => user,
  //     filterKey: ({ filterKey }) => filterKey,
  //   },
  // },
  methods: {
    onKeyup(e) {
      this.$store.dispatch("search", e.target.value);
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  padding: 12px;
  border-bottom: solid 1px #dbd9d6;
  box-sizing: border-box;
  footer {
    // margin-top: 10px;
  }

  .avatar,
  .name {
    vertical-align: middle;
  }
  .avatar {
    border-radius: 2px;
  }
  .name {
    display: inline-block;
    margin: 0 0 0 15px;
    font-size: 16px;
  }
  .search {
    padding: 0 10px;
    width: 100%;
    box-sizing: border-box;
    font-size: 12px;
    // color: #fff;
    height: 30px;
    line-height: 30px;
    border: solid 1px #dbd9d6;
    border-radius: 4px;
    outline: none;
    // background-color: #26292e;
  }
}
</style>